/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import moment from 'moment';
import { CLEAN, UPDATE } from 'actions/bonusSettings';

const initialState = {
  id: null,
  name: `Bono_${moment().format('DD_MM_YYYY_hh_mm')}`,
  description: '',
  brands: [],
  models: [],
  min_age: '',
  max_age: '',
  min_km: '',
  max_km: '',
  rule_type: 'percentage',
  branches: [],
  intervals: [
    {
      from: '',
      to: '',
      boolean: true,
      value: ''
    }
  ],
  percentage: {
    boolean: true,
    value: ''
  },
  characteristics: {
    abs: '',
    air_conditioner: '',
    alarm: '',
    central_lock: '',
    rims: '',
    checkup: '',
    condition: '',
    key_spare: '',
    steering: '',
    seat_runs: '',
    fuel_type: '',
    owners_number: '',
    collateral: '',
    transmission: '',
    traction: '',
    airbags_number: '',
    circulation_permit: '',
    doors_number: '',
    vehicle_inspection: '',
    sun_roof: '',
    vehicle_type: '',
    tapestry: ''
  }
};

const BondsSettingsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CLEAN: {
      return produce(state, draft => {
        draft = initialState;
        return draft;
      });
    }

    case UPDATE: {
      const values = action.payload;
      const initial: any = initialState;

      let final: any = {};
      for (let k in values) {
        final[k] = values[k];
        if (values[k] === null) {
          final[k] = initial[k];
        }
        if (k === 'percentage' && Object.keys(values[k]).length === 0) {
          final[k] = initial[k];
        }
        if (k === 'intervals' && values[k].length === 0) {
          final[k] = initial[k];
        }
      }
      return produce(state, draft => {
        draft = { ...draft, ...final };
        return draft;
      });
    }
    default: {
      return state;
    }
  }
};

export default BondsSettingsReducer;
